import { ProspectActivityTabs } from '../../../../../../../../../enums';

export const getEngagementTabIcon = (key: ProspectActivityTabs): string => {
  if (key === ProspectActivityTabs.All) {
    return 'layout-lists';
  }
  if (key === ProspectActivityTabs.Sent) {
    return 'send';
  }
  if (key === ProspectActivityTabs.Opened) {
    return 'eye';
  }
  if (key === ProspectActivityTabs.Clicked) {
    return 'click';
  }
  if (key === ProspectActivityTabs.Replied) {
    return 'round-corner-arrow-back';
  }

  return '';
};
